<h1 mat-dialog-title>{{ 'Asset QR code' | translate }}</h1>
<div mat-dialog-content>
  <qrcode class="qrcode" [qrdata]="data.assetId" [margin]="1" [width]="465" [errorCorrectionLevel]="'M'"></qrcode>
</div>
<div mat-dialog-actions>
  <button mat-stroked-button [mat-dialog-close]="null">{{ 'Close' | translate }}</button>
  <div class="spacer"></div>
  <button mat-flat-button color="primary" (click)="downloadQR()" cdkFocusInitial>{{ 'Download QR code' | translate }}</button>
</div>
